import { render, staticRenderFns } from "./DataTableBooleanFilter.vue?vue&type=template&id=233e2bb2&scoped=true&"
import script from "./DataTableBooleanFilter.vue?vue&type=script&lang=js&"
export * from "./DataTableBooleanFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233e2bb2",
  null
  
)

export default component.exports